import React from 'react';
import { Card, CardBody, Container } from 'reactstrap';

const NoDataDashboard = (props) => {
    const title = props.title || 'No data to display';
    const message = props.message || 'Please wait for scans to finish running';

    const content = (<div>
                        <Container fluid className="d-flex flex-grow-1 justify-content-center empty-details-block">
                            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="103" viewBox="0 0 102 103" fill="none">
                                <rect x="0.539062" y="1" width="71.8209" height="82.951" fill="#D5D9DE" stroke="#2A4057" />
                                <rect x="4.37305" y="1" width="71.8209" height="82.951" fill="#F0F2F5" stroke="#2A4057" />
                                <path d="M31.6641 14.5869H67.5745" stroke="#2A4057" />
                                <ellipse cx="18.7364" cy="14.5867" rx="5.02746" ry="5.00566" fill="#2892FA" stroke="#2A4057" />
                                <path d="M31.6641 33.1797H67.5745" stroke="#2A4057" />
                                <ellipse cx="18.7364" cy="33.1795" rx="5.02746" ry="5.00566" fill="#2892FA" stroke="#2A4057" />
                                <path d="M31.6641 51.7715H67.5745" stroke="#2A4057" />
                                <ellipse cx="18.7364" cy="51.7713" rx="5.02746" ry="5.00566" fill="#2892FA" stroke="#2A4057" />
                                <path d="M31.6641 70.3643H67.5745" stroke="#2A4057" />
                                <ellipse cx="18.7364" cy="70.3641" rx="5.02746" ry="5.00566" fill="#2892FA" stroke="#2A4057" />
                                <path
                                    d="M101.5 43.4919V51.7346V64.136C101.5 84.6313 81.0645 102 76.2838 102C71.503 102 51.0566 84.6313 51.0566 64.136V51.724V43.4919C51.0566 43.4919 61.3759 38.1846 76.2731 38.1846C91.181 38.1846 101.5 43.4919 101.5 43.4919Z"
                                    fill="#2892FA"
                                    stroke="#2A4057"
                                />
                                <path d="M92.6525 54.7099L71.5187 75.7521L61.5556 65.8322" stroke="white" strokeWidth="4" />
                            </svg>
                        </Container>
                        <h5 className="text-center">{title}</h5>
                        <p className="text-center text-muted">{message}</p>
                    </div>);

    if(props.noCard) {
        return content;
    }

    return (
        <Card className="empty-details-card">
            <CardBody>
                {content}
            </CardBody>
        </Card>
    );
};

export default NoDataDashboard;
